(() => {
  const initialise = (root) => {
    if (!root || root.dataset.ihEducationCtasReady === 'true') return;
    root.dataset.ihEducationCtasReady = 'true';
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-ih-inquiry-interest]');
      if (!link || !root.contains(link)) return;
      const target = root.querySelector('#ih-team-pilot');
      const form = target?.querySelector('form');
      if (!form) return;
      event.preventDefault();
      const topic = link.dataset.ihInquiryInterest;
      const programme = link.dataset.ihInquiryValue;
      const select = form.querySelector('select[name="contact[Programme]"]');
      if (programme && select && Array.from(select.options).some((option) => option.value === programme)) {
        select.value = programme;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      let requestedStep = form.querySelector('input[name="contact[Requested next step]"]');
      if (!requestedStep) {
        requestedStep = document.createElement('input');
        requestedStep.type = 'hidden';
        requestedStep.name = 'contact[Requested next step]';
        form.appendChild(requestedStep);
      }
      requestedStep.value = topic;
      const notice = target.querySelector('[data-ih-selected-interest]');
      if (notice) {
        notice.textContent = `${notice.dataset.label} ${topic}`;
        notice.hidden = false;
      }
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      history.replaceState(null, '', `${location.pathname}${location.search}#ih-team-pilot`);
    });
  };
  document.querySelectorAll('[data-ih-cinema]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-ih-cinema]')));
})();
